module.exports = __webpack_public_path__ + "media/images/badge-making-02cb37128669eaa8f710b53abac25dd3.svg";